// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column--centered[data-v-45d43c51]{display:flex;align-items:center}@media screen and (min-width:770px){.column--centered .field[data-v-45d43c51]{margin-top:3rem}}.no-results-text[data-v-45d43c51]{width:100%!important;white-space:normal}.no-results-text b[data-v-45d43c51]{font-weight:bolder}.no-results-text ul[data-v-45d43c51]{list-style-type:circle!important}.form-work [class^=form-][data-v-45d43c51]{margin-top:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
